import { createFileRoute } from '@tanstack/react-router'
import { FeatureGate } from '@/components/feature-locked'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/nodes'
)({
  component: StudioLayout,
})

function StudioLayout() {
  return <FeatureGate feature='image' />
}
